export const LOGGED_IN_QUERY_KEY = 'loggedIn';
